import Flag from 'components/Flag/Flag';
import * as React from 'react';
import { SingleValueProps } from 'react-select/lib/components/SingleValue';
import styled from 'styled-components';

type Props = SingleValueProps<{ label: string; value: string }>;

export const FlagPlaceholder: React.SFC<Props> = props => {
  return (
    <Container>
      <FlagContainer>
        {props.data.value !== 'global' && (
          <Flag size={32} code={props.data.value} />
        )}
      </FlagContainer>
      <Text>{props.data.label}</Text>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  cursor: pointer;
  align-items: center;
`;
const Text = styled.div`
  flex: 1;
  margin-left: 10px;
`;

const FlagContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export default FlagPlaceholder;



// WEBPACK FOOTER //
// ./src/components/FlagPlaceholder/FlagPlaceholder.tsx